// extracted by mini-css-extract-plugin
module.exports = {"icon":"userStoryIcon_icon__1ejSh","user-name":"userStoryIcon_user-name__22arV"};